
import { router } from "@/router";
import { Vue, Options } from "vue-class-component";
import { useStore } from "vuex";
import { wrapper } from "../utils/wrapper";
import ApiService from "../services/ApiService";
import StorageService from "@/services/StorageService";
import { getModuleTitle, generateImageUrl } from "../utils/modules";
import { getPageTitle, calculateActivePage } from "../utils/pages";
import { getElementDescription } from "../utils/elements";

@Options({
  props: {
    module: Object,
    language: String
  },
  methods: {
    generateImageUrl: generateImageUrl
  }
} as any)
export default class ExerciseModule extends Vue {
  module: any = null;
  language: any = null;
  title = "";
  attempts = 0;
  exercises: any = [];
  pageStateId: any = null;
  private apiService = new ApiService();
  private storageService = new StorageService();
  globalStore = useStore();
  pageState: any = null;

  user: any = null;

  async created() {
    this.attempts = this.module.modulesStates[0].attempts;
    this.title = await getModuleTitle(this.module, this.language);
    this.exercises = await this.generateExercisesArray(this.module);
    this.user = this.storageService.getUser();
    await this.getModule(this.module);
  }

  async getModule(mod: any) {
    if (mod.id) {
      const dataResponse = await wrapper(
        this.apiService.getModule(this.user.patientsId, mod.id)
      );
      if (dataResponse.error) {
        console.error("get module error ", dataResponse.error.data);
        this.globalStore.commit("open", {
          type: "danger",
          title: this.$t("ALERTS.MODULES.GET_CURRENT_MODULE.FAILED.TITLE"),
          text: this.$t("ALERTS.MODULES.GET_CURRENT_MODULE.FAILED.TEXT")
        });
      }

      if (
        dataResponse.data &&
        dataResponse.data.pages &&
        dataResponse.data.pages[0]
      ) {
        this.pageState = calculateActivePage(dataResponse.data.pages);
      }
    }
  }

  async generateExercisesArray(module: any) {
    const exercisesArray = [];
    if (module.pages) {
      // Guarantees the pages order
      module.pages = module.pages.sort((a: any, b: any) => a.order - b.order);
      for (const p of module.pages) {
        p.pageElements = (p.pageElements || []).sort(
          (a: any, b: any) => a.order - b.order
        );
        p.templateElements = (p.templateElements || []).sort(
          (a: any, b: any) => a.order - b.order
        );

        if (p.pageElements) {
          const pageTitle = getPageTitle(p, this.language);
          for (const e of p.pageElements) {
            if (!["TEXTAREA", "GO-BACK", "SUMMARY"].includes(e.options.type)) {
              const elementDescription = getElementDescription(e, this.language);

              exercisesArray.push({
                elementId: e.id,
                pageTitle: pageTitle,
                description: elementDescription,
                answered: (e.answers?.value || []).length > 0 ? true : false,
                module: module.id,
                page: e.pagesId
              });
            }
          }
        }

        if (p.templateElements) {
          const pageTitle = getPageTitle(p, this.language);
          for (const e of p.templateElements) {
            if (!["TEXTAREA", "GO-BACK", "SUMMARY"].includes(e.options.type)) {
              exercisesArray.push({
                elementId: e.id,
                pageTitle: pageTitle,
                description: e.options.description,
                answered: (e.answers?.value || []).length > 0 ? true : false,
                module: p.modulesId,
                page: p.pageElements[0].pagesId
              });
            }
          }
        }
      }
    }
    return exercisesArray.filter(e => e.description !== "TEMPLATE_ELEMENT");
  }

  async openModulePage(module: any, page: any) {
    router.push({
      name: "Page",
      params: {
        moduleId: module,
        pageId: page,
        pageStateId: this.pageState.id
      }
    });
  }
}
